export enum TypeResult {
  CLUB = 'CLUB',
  GYM = 'GYM'
}
